import { ValidateProperty } from "../../../models/utilities/validate-property";
import { ContainerPaymentType, ContainerSize, ShipmentType } from "../enums/_index";
import { ShipmentUpdate } from "../shipments/shipment-update";

export class ContainerUpdate extends ShipmentUpdate {

    public number : string = '';
    
    @ValidateProperty({ required: true})
    public size : ContainerSize | undefined = undefined;
    
    @ValidateProperty({ required: true})
    public paymentType : ContainerPaymentType | undefined = undefined;

    @ValidateProperty({ required: true })
    public carriedId : number|undefined = undefined;
    
    constructor() {
        super();
        this.type = ShipmentType.Container;
    }

}
